var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25168 13.9487C3.25108 13.961 3.25078 13.9732 3.25078 13.9855V14.1859C3.23151 15.1849 3.57084 16.1574 4.20695 16.9305C4.21852 16.9445 4.2306 16.9581 4.24316 16.9713C5.0736 17.8427 6.19315 18.3857 7.39436 18.502C10.452 18.8326 13.537 18.8327 16.5948 18.5021C17.7987 18.3901 18.9211 17.8456 19.7496 16.9691C19.76 16.9581 19.7701 16.9467 19.7798 16.9351C20.4269 16.1616 20.7715 15.1818 20.749 14.1756V13.9855C20.749 13.9743 20.7487 13.9632 20.7482 13.952C20.7147 13.2013 20.4749 12.4744 20.0556 11.8496C20.0354 11.8196 20.0132 11.7911 19.9889 11.7643C19.5316 11.2591 19.1959 10.5805 19.0447 9.89574C19.0288 9.64142 19.0318 9.39188 19.0351 9.11036L19.0354 9.08564C19.0389 8.78446 19.0422 8.44684 19.0112 8.08904L19.0112 8.08904L19.0106 8.08211C18.6727 4.55969 15.2739 2.25 12.0364 2.25H11.9634C8.72661 2.25 5.32554 4.55953 4.99809 8.08433L4.99807 8.08433L4.99767 8.08902C4.94713 8.67271 4.94839 9.21717 4.94962 9.75301C4.94975 9.80893 4.94988 9.86476 4.94995 9.92053C4.79846 10.5935 4.46565 11.2583 4.01364 11.7522C3.98705 11.7813 3.96279 11.8124 3.94108 11.8453C3.52676 12.4727 3.28853 13.1987 3.25168 13.9487Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22C10.415 22.5457 11.0244 22.899 11.6934 22.9815C12.3624 23.0639 13.0358 22.8689 13.5645 22.4395C13.7271 22.3125 13.8734 22.1648 14 22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFilled);
export default __webpack_public_path__ + "static/media/notification-filled.1c61518d073cb031345c5a8a30ce3155.svg";
export { ForwardRef as ReactComponent };